// store/index.js
import { createStore } from 'vuex';
import symbols from './modules/symbols';
import transactions from './modules/transactions';
import portfolios from './modules/portfolios';
import liabilities from './modules/liabilities';
import auth from './modules/auth';
import ui from './modules/ui';

export default createStore({
  modules: {
    symbols,
    transactions,
    portfolios,
    liabilities,
    auth,
    ui
  }
});
